import './PlanSelection.css';

import React, { useEffect, useState } from 'react';
import usePlansData from '../../hooks/usePlansData';
import { generateClassName } from '../../../b2b-common/helpers';
import B2BElementsExplorer from '../../../b2b-common/B2BElementsExplorer';
import SocialPlanCard from '../../../b2b-social/components/payload/generators/plans/SocialPlanCard';

const PlanSelection = ({ plansPerPage, selectedPlanUUID = null, className = null, onPlanSelected }) => {
    
    const { organizationPlansData, currentPlansPage, setCurrentPlansPage, isSearching, pagesCount } =
        usePlansData(plansPerPage);
    
    const [currentSelectedPlanUUID, setCurrentSelectedPlanUUID] = useState(selectedPlanUUID);
    const [currentPlansPageContent, setCurrentPlansPageContent] = useState(null);

    useEffect(() => {
        if (organizationPlansData && organizationPlansData.content) {
            setCurrentPlansPageContent(organizationPlansData);
        }
    }, [organizationPlansData]);

    const handlePageChange = (event, value) => {
        if (value < 1 || value > pagesCount) return;
        if (value !== currentPlansPage)
            setCurrentPlansPage(value);
    }

    const handlePlanSelected = (plan) => {
        setCurrentSelectedPlanUUID(plan.planUUID);
        if (onPlanSelected) {
            onPlanSelected(plan);
        }
    }

    return (
        <div className={generateClassName('b2b-plan-selection','',className)}>
            <B2BElementsExplorer
                isSearching={isSearching}
                elementsData={currentPlansPageContent}
                pagesCount={pagesCount}
                currentPage={currentPlansPage}
                handlePageChange={handlePageChange}
                className={generateClassName('b2b-plan-selection','-plans-explorer',className)}
                ElementComponent={SocialPlanCard}
                otherComponentProps={{
                    selectedPlans: currentSelectedPlanUUID ? [currentSelectedPlanUUID] : [],
                    showStatus: true,
                    showTrend: true,
                    showDatesRange: true,
                    showCalendarProgress: true,
                    showTargetProgress: true,
                }}
                elementComponentPropName='planData'
                elementComponentHandlers={{
                    onSelect: handlePlanSelected,
                    onSelectedPlanChange: null,
                }}
                elementIDPropName='plan.planId'
            />
        </div>
    );
};

export default PlanSelection;